import { connect } from 'react-redux';

import { fetchDatasets, fetchDatasetsFilters } from 'client/ducks/datasets-page/actions';
import {
    isLoading,
    hasMoreDatasets,
    getDatasets,
    getDatasetsMeta,
    getFilterYears,
    getDatasetsParams
} from 'client/ducks/datasets-page/selectors';
import { State } from 'client/store';

import DatasetsListPage, { DispatchProps, Props } from './datasets-page';

function mapStateToProps(state: State): Partial<Props> {
    return {
        hasMore: hasMoreDatasets(state),
        years: getFilterYears(state),
        rows: getDatasets(state),
        meta: getDatasetsMeta(state),
        listParams: getDatasetsParams(state),
        isLoading: isLoading(state)
    };
}

const mapDispatchToProps = {
    fetchDatasets,
    fetchFilters: fetchDatasetsFilters
};

export default connect<Partial<Props>, DispatchProps>(mapStateToProps, mapDispatchToProps)(DatasetsListPage);
